import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{attrs:{"grid-list-md":""}},[_c(VRow,{staticClass:"text-center",attrs:{"justify":"center"}},[_c(VCol,[_c('h1',[_vm._v(_vm._s(_vm.$store.state.selection.itemTypeName ? "Select " + _vm.$store.state.selection.itemTypeName : "Select"))])])],1),_c(VList,_vm._l((_vm.$store.state.selection.namedItems),function(namedItem,index){return _c(VListItem,{key:index,on:{"click":function($event){_vm.$store.state.selection.itemSelected(namedItem.item);
        _vm.$router.go(-1);}}},[_c(VListItemTitle,[_vm._v(_vm._s(namedItem.name))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }